import React, { useEffect, useState } from 'react';
import ReactDOM from 'react-dom/client';

import './../css/main.css';
import './../css/index.css';

import App from './app';

// import App from './app';
import reportWebVitals from './reportWebVitals';


if (document.getElementById('app')) {
  const app = ReactDOM.createRoot(document.getElementById('app'));
  app.render(
    <App prop={{}} />
  ); 
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
